import React, { useState } from 'react';
import { writeText } from '../../../shared/utils/clipboard';
import { useTranslation } from '../../../shared/i18n';

/**
 * Referral link card with copy functionality
 * @param {Object} props
 * @param {string} props.referralLink - The referral URL
 * @param {Object} props.translations - Translation strings
 * @param {string} props.railsEnv - Rails environment (for test IDs)
 * @param {Object} props.cashbackSettings - Cashback settings for referee benefit display
 */
const ReferralLinkCard = ({ referralLink, translations, railsEnv, cashbackSettings }) => {
  const [copied, setCopied] = useState(false);
  const { t: i18nT } = useTranslation();
  const isTestMode = railsEnv === 'test' || railsEnv === 'development';

  const handleCopy = async () => {
    try {
      await writeText(referralLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  // Same behavior as the "Chia Sẻ Ngay" button on the guardian dashboard (ReferralProgram)
  const handleShare = async () => {
    try {
      await writeText(referralLink);
      alert(i18nT('dashboard.index.referral.share_success'));
    } catch (err) {
      console.error('Failed to copy:', err);
      alert(i18nT('dashboard.index.referral.share_error'));
    }
  };


  const t = translations?.referral_link || {};

  return (
    <div className="card border-0 rounded-3 mb-4 text-white overflow-hidden" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
      <div className="card-body p-4">
        <div className="text-center mb-4">
          <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3" style={{ width: '48px', height: '48px', backgroundColor: 'rgba(255, 255, 255, 0.2)' }}>
            <i className="bi bi-people-fill" style={{ fontSize: '20px' }}></i>
          </div>
          <h3 className="h5 fw-bold mb-2">{t.title}</h3>
          <p className="small mb-0" style={{ opacity: 0.9 }}>{t.description}</p>
        </div>

        {/* Benefits Notice - show trial benefit and/or cashback benefit under single header */}
        {(t.has_trial_benefit || (cashbackSettings?.referee_cashback_percentage > 0)) && (
          <div className="alert alert-light mb-3" role="alert">
            <h6 className="fw-bold mb-2 text-dark">{t.benefits_title || 'Đặc quyền cho người được giới thiệu'}</h6>
            {/* Trial Benefit */}
            {t.has_trial_benefit && (
              <div className="d-flex align-items-start mb-1">
                <i className="bi bi-calendar-check me-2 text-primary" style={{ fontSize: '16px' }}></i>
                <p className="mb-0 small text-dark">{t.trial_benefit_description}</p>
              </div>
            )}
            {/* Cashback Benefit */}
            {cashbackSettings?.referee_cashback_percentage > 0 && (
              <div className="d-flex align-items-start">
                <i className="bi bi-percent me-2 text-success" style={{ fontSize: '16px' }}></i>
                <p className="mb-0 small text-dark">
                  {(t.cashback_benefit_description || 'Được giảm {{percentage}}%').replace('{{percentage}}', cashbackSettings.referee_cashback_percentage)}
                </p>
              </div>
            )}
          </div>
        )}

        <div className="mb-3">
          <div className="input-group flex-nowrap">
            <input
              type="text"
              className="form-control"
              value={referralLink}
              readOnly
              style={{
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                border: '1px solid rgba(255, 255, 255, 0.3)',
                color: 'white',
                minWidth: 0
              }}
              {...(isTestMode && { 'data-testid': 'referral-link-input' })}
            />
            <button
              className="btn"
              onClick={handleCopy}
              style={{
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                border: '1px solid rgba(255, 255, 255, 0.3)',
                flexShrink: 0,
                width: 'auto'
              }}
              {...(isTestMode && { 'data-testid': 'copy-button' })}
            >
              <i className={`bi ${copied ? 'bi-check2' : 'bi-clipboard'} text-white`}></i>
            </button>
          </div>
        </div>

        <button
          className="btn btn-light w-100 fw-medium"
          style={{ borderRadius: '8px', color: '#764ba2' }}
          onClick={handleShare}
        >
          <i className="bi bi-share me-2"></i>
          {i18nT('dashboard.index.referral.share_now')}
        </button>
      </div>
    </div>
  );
};

export default ReferralLinkCard;
